import { lazy } from 'react';


export const CareerCenter = lazy(() => import('./CareerCenter'));
